<template>
  <div :class="$style.container">
    <LeadForm :lead="lead.client" readonly />
    <div :class="$style.bottom">
      <div :class="$style.author">
        <p>Оформил заявку</p>
        <div>{{ lead.author.name }}</div>
      </div>
      <div :class="$style.files">
        <File
          v-for="file in lead.attachments"
          :key="file.file"
          :file="file"
          readonly
        />
      </div>
    </div>
    <div
      v-if="lead.notifications && lead.notifications.length"
      :class="$style.notifications"
    >
      <div
        v-for="i in lead.notifications"
        :key="i.id"
        :class="$style.notification"
      >
        <div>
          <img src="/icons/notification-icon.svg" alt="" />
          <div>{{ getTime(i.time_to_notify) }}</div>
        </div>
        <p>{{ i.message }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import LeadForm from "./LeadForm.vue";
import File from "../common/File.vue";
export default {
  components: {
    LeadForm,
    File,
  },
  props: {
    lead: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getTime(time) {
      let temp = time.slice(0, -4).split("T");
      temp[0] = temp[0].split("-").reverse().join(".");
      return temp.join(" ");
    },
  },
};
</script>

<style lang="scss" module>
.container {
  background-color: $bg-primary;
  padding: 1.5rem;
  .bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 2rem;
    padding: 1.5rem 0 0 0;
    .author {
      p {
        @include Body3;
        color: $t-secondary;
        margin: 0 0 0.25rem 0;
      }
      div {
        @include Title;
      }
    }
    .files {
      display: flex;
      align-items: center;
      gap: 1rem;
    }
  }
  .notifications {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 1.5rem;
    margin: 1.5rem 0 0 0;
    .notification {
      background-color: $bg-secondary;
      padding: 0.75rem;
      border-radius: 0.25rem;
      > div {
        display: flex;
        align-items: center;
        color: $red-primary;
        gap: 0.5rem;
        margin: 0 0 0.75rem 0;
        position: relative;
      }
    }
  }
}
</style>
